export async function securityHeaders(admin) {
    if (!navigator.onLine) return {};
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/security/csrf`, { credentials: "include", cache: "no-store" });
    if (!response.ok) throw new Error("Could not verify the current session. Please try again.");
    const data = await response.json();
    return data[admin ? "admin" : "user"] ? { "X-CSRF-Token": data[admin ? "admin" : "user"] } : {};
}